/* RACEIT product-page reveal choreography.
   Scoped to .raceit-* modules only. Fades cross-sell / setup / compare cards
   up as they enter the viewport and draws the accent underline on the module
   headings, to draw the eye to the revenue modules without gimmicks.

   Fully progressive: with no JS or reduced-motion the content is visible and
   static (armed state is applied by JS only). Idempotent + self-cleaning. */
(function () {
  if (window.__raceitPdpReveal) return;
  window.__raceitPdpReveal = true;

  function init() {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Section wrappers: toggled visible to draw the heading underline (no fade).
    var wrappers = Array.prototype.slice.call(
      document.querySelectorAll('.raceit-setup, .raceit-xsell')
    );

    // Fade-up targets: staggered children of the card containers.
    var fadeItems = [];
    var containers = document.querySelectorAll(
      '.raceit-setup__list, .raceit-xsell__grid, .raceit-compare__grid'
    );
    Array.prototype.forEach.call(containers, function (container) {
      Array.prototype.forEach.call(container.children, function (el, i) {
        el.classList.add('raceit-reveal');
        el.style.setProperty('--raceit-reveal-delay', Math.min(i * 70, 350) + 'ms');
        fadeItems.push(el);
      });
    });

    // Reduced motion / no IO: reveal immediately, no arming, no animation.
    if (reduce || !('IntersectionObserver' in window)) {
      wrappers.concat(fadeItems).forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    fadeItems.forEach(function (el) { el.classList.add('raceit-reveal--armed'); });

    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        obs.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    wrappers.concat(fadeItems).forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
